import React, { useContext } from 'react';
import { Context } from 'components/Store';
import { FormikInput } from 'components/UiKit/FormikFields';

const SiteId = () => {
  const [{ isEnableInfoTabEdit }] = useContext(Context);
  return (
    <FormikInput
      placeholder="Enter site ID"
      id="siteId"
      name="siteId"
      label="Site ID"
      data-testid="siteId"
      disabled={!isEnableInfoTabEdit}
    />
  );
};

export default SiteId;
